/**
 * Partner locations are free text and some are placeholders rather than places ("please see our
 * storefront", a single character). Applied to whichever service supplies the partner, so the
 * rule stays with the data rather than with the source.
 */
export const partnerLocationIsValid = (location: string) => {
  return location.length > 1 && !/please/i.test(location);
};
